import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgForm } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { TranslateTableModel } from '../../models/config/translate_table.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { TranslateTableService } from '../../service/translate_table.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { startWith, debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';

@Component({
  selector: 'app-data-dictionary',
  templateUrl: './data-dictionary.component.html',
  styleUrls: ['./data-dictionary.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DataDictionaryComponent implements OnInit {

  public transModel = new TranslateTableModel();
  public trans: TranslateTableModel[] = [];
  public loggedinUser: string = '';
  public errorMessage: string = '';
  public sucessMessage: string = '';
  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public checkedactive: boolean = false;
  public selctedViews: TranslateTableModel[] = [];
  public selctedViewsUncheck: TranslateTableModel[] = [];
  public selctedEdits: TranslateTableModel[] = [];
  public isTableExpanded = false;
  public showLoading: boolean;
  public fname: string;
  expandedElement: null;

  public dataSource = new MatTableDataSource<TranslateTableModel>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  public displayedColumns = ['field_name', 'update'];

  filteredFieldNameOptions: Observable<any[]>;
  myControl = new FormControl();

  // GRID FRAMEWORK
  ordersTableColumns1: TableColumn[];
  ordersTableColumns2: TableColumn[];
  columnsData: any;
  actions: any;
  checkbox: any;
  actionButtons: any;

  public fieldData: TranslateTableModel[] = [];
  public fieldValueData: TranslateTableModel[] = [];
  public excelAdminConfigList: TranslateTableModel[] = [];

  columnsExcelData: any;
  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];

  isAccessDisabled: boolean = false;
  public resFieldNames: TranslateTableModel[] = [];

  constructor(private globalService: GlobalService, private translateTableService: TranslateTableService,
    public ete: ExportExcelService, private httpService: HttpClient, private authGaurdService: AuthGaurdService, private notificationService: NotificationService) {
    this.getNames();
  }

  ngOnInit() {
    //Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('data-dictionary');

    this.loggedinUser = this.authGaurdService.loginUser();
    this.initializeColumns();
    this.getTransList();
    this.getExcelTransList();
    this.initializeExcelHeaders();
  }

 

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.adminConfig;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {
    for (let js of this.excelAdminConfigList) {
      delete js.id;
      delete js.fieldValues;
      delete js.comment;
      delete js.created_dt;
      delete js.created_by;
      delete js.updated_dt;
      delete js.updated_by;
    }
    this.dataForExcel = [];
    let reportData = null;
    this.excelAdminConfigList.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row));
    })
     reportData = {
      title: 'AdminConfig',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.ete.exportExcel(reportData);
  }

  getNames() {
  
    this.filteredFieldNameOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(val => {
        return this.getFieldNames(val || '')
      })
    )
  }

  getFieldNames(val: string): Observable<any[]> {
    
    return this.translateTableService.getFieldNames()
      .pipe(
        map(response => response.filter(option => {
          this.resFieldNames = response;
          return option.field_name.toLowerCase().indexOf(val.toLowerCase()) === 0
        }))
      )
  }

  public getSelectedFieldNames(desc: string) {
    console.log("desc = " + desc);
    if (desc === null || desc === "") {
      return null;
    } else {
      return this.resFieldNames?.find(cat => cat.field_name === desc).field_name;
    }
  }



  public onEditFieldValues(editFieldValuesName: TranslateTableModel): void {
   
    this.transModel = editFieldValuesName;
    this.clickButton('openValueEdit');
  }

  

  public onEditFieldName(editFieldName: TranslateTableModel, field_name): void {
    
    this.transModel = editFieldName;
    this.fname = field_name;
    this.clickButton('openNameEdit');
  }


  public onUpdateFieldName(): void {
   
      const formData = this.translateTableService.createTransForm(this.transModel, this.fname);
      this.subscriptions.push(
        this.translateTableService.updateFieldName(formData).subscribe(
          (response: TranslateTableModel) => {
            this.clickButton('closeEditFiledNameModalButton');
            this.getTransList();
            this.notificationService.sendNotification(NotificationType.SUCCESS, `Field name updated successfully`);
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          }
        )
      );
    
  }


  public addTrans(pageForm: NgForm): void {
    this.showLoading = true;
    pageForm.value.field_name = this.transModel.field_name;
    const formData = this.translateTableService.createForm(pageForm.value);
    this.subscriptions.push(
      this.translateTableService.addTrans(formData).subscribe(
        (response: TranslateTableModel) => {
          this.getNames();
          this.getTransList();
          this.clickButton('new-trans-close');
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Added successfully`);
          pageForm.reset();
          this.showLoading = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.showLoading = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public onUpdateFieldValue(): void {
    const formData = this.translateTableService.createForm(this.transModel);
    this.subscriptions.push(
      this.translateTableService.updateFieldValue(formData).subscribe(
        (response: TranslateTableModel) => {
          this.clickButton('closeEditFiledValueModalButton');
          this.getTransList();
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Updated successfully`);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
}

  public getTransList(): void {
    
    this.refreshing = true;
    this.subscriptions.push(
      this.translateTableService.getTransList().subscribe(
        (response: TranslateTableModel[]) => {
          this.fieldData = response;
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }
  public getExcelTransList(): void {
    
    this.refreshing = true;
    this.subscriptions.push(
      this.translateTableService.getExcelTransList().subscribe(
        (response: TranslateTableModel[]) => {
          this.excelAdminConfigList = JSON.parse(JSON.stringify(response));
          console.log();
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getTransFieldValuesList(field_name: string): void {
  
    this.refreshing = true;
    this.subscriptions.push(
      this.translateTableService.getTransFieldValuesList(field_name).subscribe(
        (response: TranslateTableModel[]) => {
          this.fieldValueData = response;
          console.log(this.fieldValueData);
          //this.dataSource.data = response as TranslateTableModel[];
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public saveNewTrans(): void {
    this.clickButton('new-trans-save');
  }

  // GRID FRAMEWORK
  innerRowAction1(row: any) {
    if (row.value === 'View') {
      this.getTransFieldValuesList(row.row.field_name);
    }
    if (row.value === 'Update') {
      
      this.onEditFieldName(row.row, row.row.field_name);
    }
  }
  innerRowAction2(row: any) {
    if (row.value === 'Update') {
      
      this.onEditFieldValues(row.row);
    }
  }

  actionOnButton(action: any) {
    if (action === "Add") {
      console.log("called add")
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.clickButton(action);
      }
    }
  }

  private clickButton(buttonId: string): void {
    console.log("called update");
    document.getElementById(buttonId).click();
  }

  update(user: any, values: any) {

  }

  initializeColumns(): void {
    
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns2 = this.columnsData.AdminConfigSubData;
        this.ordersTableColumns1 = this.columnsData.AdminConfigData;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );

    this.actions = [
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      }
    ]

    this.actionButtons = [
      {
        name: 'Add',
        class: 'btn btn-success btn-xs'
      }
    ]

  }

}